import React from 'react';
import { DelayedInlineLoading } from '../components';
export function withSuspense(LazyComp, Loading) {
    function WithSuspense(props) {
        return (React.createElement(React.Suspense, { fallback: Loading ? React.createElement(Loading, null) : null },
            React.createElement(LazyComp, { ...props })));
    }
    // @ts-ignore
    WithSuspense.displayName = `WithSuspense(${LazyComp.displayName || LazyComp.name || 'Component'})`;
    return WithSuspense;
}
export function withSuspenseLazy(ctor, Loading = DelayedInlineLoading) {
    return withSuspense(React.lazy(ctor), Loading);
}
//# sourceMappingURL=lazy.js.map